var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"type":"type"},domProps:{"textContent":_vm._s(_vm.formatted)}})
}
var staticRenderFns = []

export { render, staticRenderFns }